/**
 * @generated SignedSource<<573f9dfc333fede7d065d1c79f38be13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TaskKind = "other" | "measurement" | "cleaning" | "%future added value";
export type UserErrorCode = "INVALID_CREDENTIALS" | "INVALID_ARGUMENTS" | "UNAUTHORIZED_ACCESS" | "CONFLICTING_ORGANIZATIONS" | "RECORD_NOT_FOUND" | "%future added value";
export type CreateTaskTemplateInput = {
  name: string;
  taskKind: TaskKind;
  measurementTemplateId?: string | null;
  clientMutationId?: string | null;
};
export type createPageCreateTaskTemplateMutation$variables = {
  input: CreateTaskTemplateInput;
};
export type createPageCreateTaskTemplateMutationVariables = createPageCreateTaskTemplateMutation$variables;
export type createPageCreateTaskTemplateMutation$data = {
  readonly createTaskTemplate: {
    readonly taskTemplate: {
      readonly id: string;
      readonly createdAt: any;
      readonly name: string;
      readonly taskKind: TaskKind;
      readonly measurementTemplate: {
        readonly id: string;
      } | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly code: UserErrorCode;
      readonly fields: ReadonlyArray<{
        readonly fieldName: string;
        readonly message: string;
      }> | null;
    }>;
  } | null;
};
export type createPageCreateTaskTemplateMutationResponse = createPageCreateTaskTemplateMutation$data;
export type createPageCreateTaskTemplateMutation = {
  variables: createPageCreateTaskTemplateMutationVariables;
  response: createPageCreateTaskTemplateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateTaskTemplatePayload",
    "kind": "LinkedField",
    "name": "createTaskTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TaskTemplate",
        "kind": "LinkedField",
        "name": "taskTemplate",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskKind",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "MeasurementTemplate",
            "kind": "LinkedField",
            "name": "measurementTemplate",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "UserError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserFieldError",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fieldName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createPageCreateTaskTemplateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createPageCreateTaskTemplateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "1eba6d790f4a902e2509904f006c4314",
    "id": null,
    "metadata": {},
    "name": "createPageCreateTaskTemplateMutation",
    "operationKind": "mutation",
    "text": "mutation createPageCreateTaskTemplateMutation(\n  $input: CreateTaskTemplateInput!\n) {\n  createTaskTemplate(input: $input) {\n    taskTemplate {\n      id\n      createdAt\n      name\n      taskKind\n      measurementTemplate {\n        id\n      }\n    }\n    errors {\n      code\n      fields {\n        fieldName\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "104a536e42e07855c2c31bef82549369";

export default node;
